import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  RESET,
  GET_CITY_LIST_SUCCESS,
  GET_COUNTRY_LIST_SUCCESS,
  GET_CLAIM_TYPES_SUCCESS,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    dateOfEvent: '',
    timeOfEvent: null,
    country: '',
    city: '',
    storyEvent: '',
    // totalAmount: '',
    title: '',
    firstName: '',
    surName: '',
    dateOfBirth: '',
    relationshipToYou: '',
    dateYouFirstBecomeAware: '',
    detailOfMedicalCondition: '',
    dateBookedTrip: '',
    dateScheduledToDepart: '',
    dateOriginallyScheduled: '',
    selectedBenefits: [],
  },
  countryList: [],
  cityList: [],
  claimTypeList: [],
});

function step5Reducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({
          form: action.payload,
          countryList: state.getIn(['countryList']),
          cityList: [],
          claimTypeList: state.getIn(['claimTypeList']),
        })
        : initialState;
    case RESET:
      return initialState;
    case GET_COUNTRY_LIST_SUCCESS:
      return state.setIn(['countryList'], action.countries);
    case GET_CITY_LIST_SUCCESS:
      return state.setIn(['cityList'], action.cities);
    case GET_CLAIM_TYPES_SUCCESS:
      return state.setIn(['claimTypeList'], action.claimTypeList);
    default:
      return state;
  }
}

export default step5Reducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step5/reducer.js